import { CircularProgress, CssBaseline, FormControl, FormHelperText, Grid, TextField, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/lab';
import { CommonService } from '../../../../services';
import PropTypes from 'prop-types';
import _ from "lodash/fp";
import useStyles from '../../CommonStyle/CommonStyle';
import { FormattedMessage } from 'react-intl';
import { GlobalEdiApiConstants } from '../../../../Constants/GlobalEdiApiConstants';

const PcnNumberCombo = (props) => {
    
    const classes = useStyles();
    const { comboProperty, control, errors, comboValue, setComboValue } = props;
    const [pcnNumberList, setPcnNumberList] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const pcnNumberData = pcnNumberList.map((partChangeNotification) => {
        return { messageIdmsgHdrId: partChangeNotification.msgHdrId, pcnNo: partChangeNotification.pcnNo }
    });
    const apiUrlAndParamBodyConstants = GlobalEdiApiConstants();

    const [searchedPcnNumber, setSearchedPcnNumber] = useState(null);

    const [paramBody, setParamBody] = useState(apiUrlAndParamBodyConstants.paramBodyForGetListApis.advanceShipmentNoteHdrs);

    useEffect(() => {
        if (searchedPcnNumber !== null) {
            setParamBody({ ...paramBody, body: { pcnNo: searchedPcnNumber, approved: '', recordStatusFlag: 'All', recordApprovedStatus: 'All', }, sortDir: 'asc', sortKey: 'pcnNo', recordsPerPage: 100 });
        }
    }, [searchedPcnNumber]);

    useEffect(() => {
        if (paramBody.sortDir !== 'desc' && paramBody.sortKey !== 'updatedTime') {
            loadOrgData();
        }
    }, [paramBody]);

    const loadOrgData = (searchedPcnNumber) => {
        setLoading(true);
        CommonService.GetListApi(apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.advanceShipmentNoteHdrs, paramBody)
            .then((response) => {
                setLoading(false);
                setPcnNumberList(response.data.content);
            })
    }


    return (
        <React.Fragment>
            <CssBaseline />
            { comboProperty.isHookFormType && (<Grid item xs={12} sm={12} md={12} lg={12}>
                <FormControl fullWidth>
                    <Controller
                        render={({
                            field: { onChange } }) => (
                            <Autocomplete

                                onChange={(event, newValue) => {
                                    onChange(newValue)

                                    if (typeof newValue === 'string') {

                                        if (newValue != null) {
                                            setComboValue({
                                                newValue,
                                            });
                                        }
                                    } else if (newValue && newValue.inputValue) {
                                        // Create a new value from the user input
                                        setComboValue({
                                            title: newValue.inputValue,
                                        });

                                    }
                                    else if (newValue !== null) {

                                        setComboValue(newValue);
                                    } else if (newValue === null) {
                                        setComboValue('')
                                    } else {
                                        setComboValue(newValue);
                                    }
                                }}
                                selectOnFocus
                                handleHomeEndKeys
                                value={comboValue.pcnNo || null}
                                autoHighlight
                                loadingText="Loading..."
                                loading={isLoading}
                                onOpen={() => {
                                    setSearchedPcnNumber('');
                                }}
                                options={pcnNumberData}
                                getOptionLabel={(option) => {

                                    if (typeof option === 'string') {
                                        return option;
                                    }
                                    if (option.inputValue) {
                                        return option.inputValue;
                                    }
                                    return option.shipmentNumber;
                                }}
                                getoptionselected={(option, value) => option.pcnNo === value}
                                disabled={comboProperty.isDisabled}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        className={classes.textField}
                                        required={comboProperty.isRequired}
                                        autoFocus={comboProperty.isAutofocus}
                                        name={comboProperty.name}
                                        size='small'
                                        error={comboProperty.errors}
                                        label={comboProperty.label}
                                        variant={comboProperty.variant}
                                        InputLabelProps={{
                                            shrink: true,
                                            classes: {
                                                asterisk: classes.asterisk
                                            }
                                        }}
                                    />
                                )}

                            />
                        )}

                        name={comboProperty.name}
                        rules={{ required: comboProperty.isRequired }}
                        control={control}
                        defaultValue={{ erpOrgCode: '', orgName: '' }}
                    />
                    {comboProperty.isDisabled}
                    <div className={classes.error}>
                        {_.get(`${comboProperty.name}.type`, errors) === "required" && (
                            <FormHelperText className={classes.error}>{comboProperty.label} <FormattedMessage id="textfield.error.isrequirededmessage" defaultMessage="is required" /></FormHelperText>
                        )}
                    </div>
                </FormControl>
            </Grid>)}

            { !comboProperty.isHookFormType && (<Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: "3px" }}>
                <FormControl fullWidth>
                    <Autocomplete
                        fullWidth
                        openOnFocus={true}
                        onChange={(event, newValue) => {
                            if (typeof newValue === 'string') {

                                if (newValue != null) {
                                    setComboValue({
                                        newValue,
                                    });
                                }
                            } else if (newValue && newValue.inputValue) {
                                // Create a new value from the user input
                                setComboValue({
                                    title: newValue.inputValue,
                                });

                            }
                            else if (newValue !== null) {

                                setComboValue(newValue);
                            } else if (newValue === null) {
                                setComboValue('')
                            } else {
                                setComboValue(newValue);
                            }
                        }}
                        selectOnFocus
                        loadingText="Loading..."
                        loading={isLoading}
                        handleHomeEndKeys
                        value={comboValue.pcnNo || null}
                        autoHighlight
                        onOpen={() => {
                            setSearchedPcnNumber('');
                        }}
                        options={pcnNumberData}
                        getOptionLabel={(option) => {

                            if (typeof option === 'string') {
                                return option;
                            }
                            if (option.inputValue) {
                                return option.inputValue;
                            }
                            return option.pcnNo;
                        }}
                        getoptionselected={(option, value) => option.pcnNo === value}
                        disabled={comboProperty.isDisabled}
                        renderInput={params => (
                            <Tooltip title={comboValue.pcnNo || ''}>
                                <TextField
                                    {...params}
                                    autoFocus={comboProperty.isAutofocus}

                                    name={comboProperty.name}
                                    InputLabelProps={{
                                        shrink: true,

                                    }}
                                    onChange={(ev) => {
                                        if (
                                            ev.target.value !== "" ||
                                            ev.target.value !== null
                                        ) {
                                            setSearchedPcnNumber(ev.target.value);
                                        }
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {isLoading ?
                                                    <CircularProgress color="inherit" size={20} />
                                                    : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                    size='small'
                                    label={comboProperty.label + (comboProperty.isRequired ? ' *' : '')}
                                    variant={comboProperty.variant}
                                />
                            </Tooltip>
                        )}

                    />
                </FormControl>
            </Grid>)}

        </React.Fragment>
    );
};

PcnNumberCombo.propTypes = {
    comboProperty: PropTypes.object.isRequired,
    control: PropTypes.any,
    errors: PropTypes.any,
    comboValue: PropTypes.any.isRequired,
    setComboValue: PropTypes.func.isRequired
};

export default  PcnNumberCombo;